/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2022-07-20 10:02:38
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-14 13:48:51
 */
import './config.js'
import api from "../api";
//引入平台级元数据
import '../metadata';
//引入平台使用的vuex的store
import store from '../store';
//语言包
import i18n from '../i18n';

import polygonToLine from '@turf/polygon-to-line';
import centroid from '@turf/centroid';
import simplify from '@turf/simplify';
import { multiPolygon, point, polygon, lineString, featureCollection } from '@turf/helpers';
import tinycolor from 'tinycolor2';
import * as mixins from '../mixins';

window.tinycolor = tinycolor
window.turf = {
  polygonToLine,
  centroid,
  simplify,
  multiPolygon,
  point,
  polygon,
  lineString,
  featureCollection
}

!function (global) {

  //注册api
  api(dsf);
  dsf.mix(true, global.$mixins, { ...mixins });
  dsf.mix(true, global.$i18n, { ...i18n });
  dsf.mix(true, global.$platformStore, { ...store });

  // dsf.mix(true, global.$effectsMap, effectsMap);

}(dsf.global || (dsf.global = {}))
